import { BookOpen } from "lucide-react";
import ResourceShellTemplate from "./ResourceShellTemplate";

export default function BlogShell() {
  return (
    <ResourceShellTemplate
      slug="blog"
      eyebrow="Resources · Blog"
      title="Field notes."
      titleAccent="Product deep-dives."
      subtitle="Long-form pieces on deterministic engines, the anatomy of an AI recommendation, and lessons from acquisitions teams running the platform in production."
      icon={BookOpen}
      previewItems={[
        { title: "Why the AI Coach caps confidence at 60% when comps are thin", desc: "The math behind grounding — and why hallucinated conviction is more dangerous than a low-confidence answer.", meta: "Deep-dive · #01" },
        { title: "8 exit strategies, one scoring model — how BP-014 stays deterministic", desc: "A walkthrough of the factor extractors, capital penalties, and Why-Not audit that ends strategy debates.", meta: "Engineering · #02" },
        { title: "Timeline as source of truth: what we learned from 40,000+ audits", desc: "Immutable event logs stopped being a compliance nice-to-have and became a product superpower.", meta: "Architecture · #03" },
      ]}
    />
  );
}
